import { defineComponent as _defineComponent } from 'vue'
import BCXButton from '@/components/molecules/BCXButton.vue';
import BCLoadingAnimation from '@/components/molecules/BCLoadingAnimation.vue';
import BCXContentArea from '@/components/molecules/BCXContentArea.vue';
import BCXItemsWithPoints from '@/components/molecules/BCXItemsWithPoints.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TestingArea',
  setup(__props) {

const loadingAnimations = [1, 2];

return { __sfc: true,loadingAnimations, BCXButton, BCLoadingAnimation, BCXContentArea, BCXItemsWithPoints }
}

})